import type { PageNumber } from "@pdfking/renderer-api"
import { RecordCreate } from "@pdfking/tfunc"
export const PageNumbersToSheetCoverIndex = (
  sheet_cover_page_numbers: PageNumber[]
): Record<PageNumber, number> => RecordCreate(sheet_cover_page_numbers.map((page, i) => [page, i]))
